module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_recent.cc830.png";